import { render, staticRenderFns } from "./StockListOnPlate.vue?vue&type=template&id=2f5735ec&scoped=true"
import script from "./StockListOnPlate.vue?vue&type=script&lang=js"
export * from "./StockListOnPlate.vue?vue&type=script&lang=js"
import style0 from "./StockListOnPlate.vue?vue&type=style&index=0&id=2f5735ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5735ec",
  null
  
)

export default component.exports